<template>
  <v-product-card :color="color" hover :product="item" ripple @click="toggle">
    <!-- All the predictions for this item -->
    <!-- The validation date if the item is validated -->
    <v-item-card-validation-data v-if="item.validated" :item="item" />
  </v-product-card>
</template>

<script>
import VItemCardValidationData from "./ItemCardValidationData";
import VProductCard from "@/components/cards/CardProduct.vue";

/**
 * A component to render a card with the data of the matching item.
 */
export default {
  components: {
    VItemCardValidationData,
    VProductCard,
  },
  props: {
    /**
     * The item to show with this card.
     */
    item: {
      type: Object,
      required: true,
      validator: (value) => !!value.name,
    },
  },
  computed: {
    color() {
      if (this.item.correct) return "light-green lighten-4";
      if (this.item.correct === false) return "red lighten-4";
      return "white";
    },
  },
  methods: {
    /**
     * Toggle the correct state of the given item.
     */
    toggle() {
      this.$store.commit("classifier/toggleCorrect", this.item);
    },
  },
};
</script>
